<div id="languageSelector" fxLayout="row" fxLayoutAlign="center center">
<button [matMenuTriggerFor]="menu" aria-label="Language Selector" type="button" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="5px">
    <mat-icon>language</mat-icon>
    <span id="selectedLanguage"> ({{ languageCode }})</span>
    <mat-icon>arrow_drop_down</mat-icon>
  </button>
  <mat-menu #menu="matMenu">
    <button
      *ngFor="let l of _languageService.languages"
      mat-menu-item
      [value]="l"
      (click)="changeLang(l)"
    >
      <span>{{l}}</span>
    </button>
  </mat-menu>
</div>
  